@if (label) {
  <div [innerHtml]="label" class="u-textarea-label"></div>
}

@if (formControl(); as control) {
  <!-- Using reactive forms when formControl is provided -->
  <textarea
    [formControl]="control"
    [rows]="rows"
    [cols]="cols"
    [placeholder]="placeholder"
    [style]="styles"
    [disabled]="disabled"
    [attr.maxLength]="maxLength || null"
    [ngClass]="{
      'disable-auto-resize': disableAutoResize,
      truncate: control.value?.length && !isTitleFocused && truncateLines,
      'max-resize-with-scroll': autoResize && !doResize,
      'fixed-background-color': fixedBackgroundColor,
      'error-border': errorBorder,
    }"
    (focus)="onFocusEvent($event)"
    (blur)="onBlurEvent($event)"
    (keydown)="onKeydown($event)"
    (keydown.enter)="onEnterEvent($event)"
    (click)="handleTextareaClick()"
    [readonly]="readonly"
    [autoResize]="doResize"
    pInputTextarea
    class="u-textarea"
    name="uTextarea"
    ngDefaultControl
    dir="auto"
    #textarea
  ></textarea>
} @else {
  <!-- Using template-driven approach when no formControl -->
  <textarea
    [rows]="rows"
    [cols]="cols"
    [placeholder]="placeholder"
    [style]="styles"
    [disabled]="disabled"
    [attr.maxLength]="maxLength || null"
    [ngClass]="{
      'disable-auto-resize': disableAutoResize,
      truncate: model?.length && !isTitleFocused && truncateLines,
      'max-resize-with-scroll': autoResize && !doResize,
      'fixed-background-color': fixedBackgroundColor,
      'error-border': errorBorder,
    }"
    [(ngModel)]="model"
    (ngModelChange)="onChangeEvent($event)"
    (focus)="onFocusEvent($event)"
    (blur)="onBlurEvent($event)"
    (keydown)="onKeydown($event)"
    (keydown.enter)="onEnterEvent($event)"
    (click)="handleTextareaClick()"
    [readonly]="readonly"
    [autoResize]="doResize"
    pInputTextarea
    class="u-textarea"
    name="uTextarea"
    ngDefaultControl
    dir="auto"
    #textarea
  ></textarea>
}

@if (displayLimitWarning && !isValidLength()) {
  <div class="max-char-warning">{{ MAX_INPUT_WORDS_REACHED_MSG }}</div>
}
@if (currentErrorText()) {
  <div class="error-text">{{ currentErrorText() }}</div>
}
